import Popup from "@client/content/controls/Popup/component";
import { getRootContainerProps } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import React from "react";
import Form from "../Form/container";

export type MapProps = RootContainerProps & {
  isVisible: boolean;
};

export type ActionProps = {
  onClose: () => void;
};

export default (props: ActionProps & MapProps) => (
  <Popup {...props}>
    <Form {...getRootContainerProps(props)} isInPopup />
  </Popup>
);
